import React, { FC } from 'react';

import './Tooltip.scss';

export type TooltipVisibility = "" | "visible" | "showOnHover"

interface IProps {
    visibility: TooltipVisibility
}

const Tooltip: FC<IProps> = (props) => {
    const { visibility, children } = props

    return <div className={`Tooltip ${visibility}`}>
        {children}
    </div>
}

export default Tooltip;